import { AreaOfInterestEnum } from '../enums/area-of-interest-enum';

/**
 * Reglas y rangos de negocio del módulo de monitoreo (totalizadores y límites
 * de los sliders de pérdida de bosque, detecciones y cobertura forestal).
 */
export class MonitoringConstant {
  static readonly DEFAULT_AREA_OF_INTEREST = AreaOfInterestEnum.DrawPolygon;

  /** Rango de años del deslizador de pérdida de bosque. */
  static readonly LOSS_SLIDER_MIN = 2001;
  static readonly LOSS_SLIDER_MAX = 2024;

  /** Rango de años del mapa de bosque (detección). */
  static readonly FOREST_MAP_MIN = 2010;
  static readonly FOREST_MAP_MAX = 2023;

  /** Rango de porcentaje de cobertura forestal (detección). */
  static readonly COVERAGE_MIN = 10;
  static readonly COVERAGE_MAX = 95;
}